"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PluralMessage = exports.formatPluralMessage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const textUtils_1 = require("./textUtils");
const formatPluralMessage = (count, values) => {
    const text = (0, textUtils_1.pluralText)(count, values.one, values.few, values.many, values.none);
    return (0, textUtils_1.replaceValues)(text, {
        count
    });
};
exports.formatPluralMessage = formatPluralMessage;
const PluralMessage = ({ count, ...values }) => {
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, exports.formatPluralMessage)(count, values) }));
};
exports.PluralMessage = PluralMessage;
